import React from 'react';
import { useLanguage } from './LanguageContext';

const translations = {
  en: {
    title: 'Tonight\'s dinner is hiding in your fridge.',
    subtitle: 'Open it. Snap it. Eat it. Chaiffy does everything in between.',
    cta: 'Start Cooking',
    note: 'Available for Mobily customers · 11.5 SAR/week · Cancel anytime',
  },
  ar: {
    title: 'عشاء الليلة مختبئ في ثلاجتك.',
    subtitle: 'افتحها. صوّرها. كُلها. Chaiffy يتكفل بكل شي بينهم.',
    cta: 'ابدأ الطبخ',
    note: 'متاح لعملاء موبايلي · 11.5 ريال/أسبوع · إلغاء في أي وقت',
  }
};

const CTA = () => {
  const { language, isRTL } = useLanguage();
  const t = translations[language];

  return (
    <section className="relative" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="bg-dark py-20 md:py-28 px-4 relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-[20%] w-72 h-72 bg-emerald-600/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-[10%] w-96 h-96 bg-teal-600/10 rounded-full blur-3xl"></div>
        </div>

        <div className="container mx-auto max-w-3xl text-center relative z-10">
          <div className="text-5xl mb-8">🍳</div>
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mb-6 leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
            {t.title}
          </h2>
          
          <p className="text-lg md:text-xl text-gray-400 mb-10 max-w-xl mx-auto leading-relaxed" style={{ fontFamily: 'Lato, sans-serif' }}>
            {t.subtitle}
          </p>
          
          <a 
            href="/start"
            className="inline-flex items-center gap-3 px-10 py-5 bg-gradient-green text-white rounded-2xl text-lg md:text-xl font-bold hover:opacity-90 transition-all duration-300 shadow-2xl shadow-emerald-900/30 transform hover:-translate-y-1"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            {t.cta}
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d={isRTL ? "M19 12H5M12 5l-7 7 7 7" : "M5 12h14M12 5l7 7-7 7"} />
            </svg>
          </a>

          <p className="text-sm text-gray-600 mt-8" style={{ fontFamily: 'Lato, sans-serif' }}>
            {t.note}
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTA;
